import tick from './../assets/tick.png';

type Props = {
    text: string;
}

function TickLabel({ text }: Props) {
    return (
        <div className="flex flex-row my-2 w-50 xl:w-96">
            <img src={tick} className="size-6" />
            <span className='font-regular text-white text-xl pl-3'>{text}</span>
        </div>
    )
}

export default TickLabel